import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';
import m from 'mithril';
const T = function (k, p) {
  if (p === void 0) {
    p = {};
  }
  return app.translator.trans(`linkrobins-lr-monitoring.forum.pro.${k}`, p);
};

/** The viewer's Pro membership, from lr-billing's forum fields (ProFields). */
function pro() {
  const f = app.forum;
  return {
    visible: !!f.attribute('lrProVisible'),
    active: !!f.attribute('lrProActive'),
    source: f.attribute('lrProSource'),
    status: f.attribute('lrProStatus'),
    until: f.attribute('lrProUntil'),
    graceUntil: f.attribute('lrProGraceUntil'),
    cancelling: !!f.attribute('lrProCancelling'),
    price: f.attribute('lrProPrice') || 60,
    monthlyPrice: f.attribute('lrProMonthlyPrice') || 6,
    // A paid member's own renewal amount and interval (their Stripe price).
    renewAmount: f.attribute('lrProRenewAmount'),
    interval: f.attribute('lrProInterval'),
    // Set only while this member can still earn the review bonus (ProService::reviewBonusOfferFor).
    reviewDeadline: f.attribute('lrProReviewDeadline'),
    billingEnabled: !!f.attribute('lrBillingEnabled'),
    testMode: f.attribute('lrBillingMode') === 'test' && f.attribute('lrBillingSiteMode') === 'live'
  };
}
const day = iso => iso ? new Date(iso).toLocaleDateString(undefined, {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}) : '';

/**
 * Link Robins Pro, as a modal (Karl, 2026-10-06: "would it make sense if the
 * pro page was just a modal?"). Opened from the dashboard sidebar card, from a
 * "Pro" tag on a locked option, and after Stripe returns from checkout.
 *
 * Buying and billing are Stripe's (Checkout, then the customer portal); this
 * only starts them and reports the membership lr-billing keeps.
 */

export default class ProModal extends FormModal {
  busy = false;
  error = '';
  /** Monthly or yearly (Karl, 2026-10-16: $6 a month or $60 a year). */
  billing = 'year';
  oninit(vnode) {
    super.oninit(vnode);
    // Stripe returns before its webhook has necessarily landed; reload the
    // forum payload once shortly after so the new membership shows.
    if (this.attrs.welcome && !pro().active) {
      setTimeout(() => this.refresh(), 4000);
    }
  }
  className() {
    // The same frame as every other dashboard modal (MonitorModal, StatusPageModal).
    return 'Modal--medium LrMon-modal LrProModal';
  }
  title() {
    return T('title');
  }
  content() {
    const p = pro();
    return m("div", {
      className: "Modal-body"
    }, p.testMode ? m("div", {
      className: "Alert"
    }, T('test_mode')) : null, this.attrs.welcome ? m("div", {
      className: "Alert Alert--success"
    }, p.active ? T('welcome_done') : T('welcome_pending')) : null, this.attrs.reason && !p.active ? m("div", {
      className: "Alert"
    }, T('reason', {
      feature: this.attrs.reason
    })) : null, this.error ? m("div", {
      className: "Alert Alert--error"
    }, this.error) : null, p.active ? this.member(p) : this.offer(p));
  }
  member(p) {
    let line;
    const inGrace = p.until && new Date(p.until) < new Date();
    if (p.source === 'lifetime') line = T('status.lifetime');else if (p.source === 'grandfathered') line = T('status.grandfathered', {
      date: day(p.until)
    });else if (p.source === 'manual') line = p.until ? T('status.manual_until', {
      date: day(p.until)
    }) : T('status.manual');else if (inGrace) line = T('status.grace', {
      date: day(p.until),
      grace: day(p.graceUntil)
    });else if (p.status === 'past_due') line = T('status.past_due');else if (p.cancelling) line = T('status.cancelling', {
      date: day(p.until)
    });else if (p.status === 'active' && p.until) line = T('status.renews', {
      date: day(p.until),
      price: p.renewAmount ?? (p.interval === 'month' ? p.monthlyPrice : p.price)
    });else line = T('status.active');
    return [m("div", {
      className: "Form-group"
    }, m("label", null, T('you_have')), m("p", {
      className: "helpText"
    }, line), p.reviewDeadline ? m("p", {
      className: "helpText"
    }, T('review_hint', {
      date: day(p.reviewDeadline)
    })) : null), m("div", {
      className: "Form-group"
    }, m("label", null, T('includes')), this.features()), p.source === 'grandfathered' && p.billingEnabled ? m("div", {
      className: "Form-group"
    }, m("label", null, T('billing_label')), this.billingChoice(p)) : null, m("div", {
      className: "Form-group LrMon-modalFoot"
    }, p.source === 'stripe' ? m(Button, {
      className: "Button Button--primary",
      type: "button",
      loading: this.busy,
      onclick: () => this.portal()
    }, T('manage')) : null, p.source === 'grandfathered' && p.billingEnabled ? m(Button, {
      className: "Button Button--primary",
      type: "button",
      loading: this.busy,
      onclick: () => this.checkout()
    }, T('subscribe_early', {
      date: day(p.until)
    })) : null, m(Button, {
      className: "Button LrMon-modalDelete",
      type: "button",
      onclick: () => this.hide()
    }, T('close')))];
  }
  offer(p) {
    return [m("div", {
      className: "Form-group"
    }, m("label", null, T('includes')), m("p", {
      className: "helpText"
    }, T('lede')), this.features()), m("div", {
      className: "Form-group"
    }, m("label", null, T('billing_label')), this.billingChoice(p), m("p", {
      className: "helpText"
    }, T('refund'))), m("div", {
      className: "Form-group LrMon-modalFoot"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.busy,
      disabled: !p.billingEnabled
    }, T('buy_short')), m(Button, {
      className: "Button LrMon-modalDelete",
      type: "button",
      onclick: () => this.hide()
    }, T('not_now')))];
  }
  onsubmit(e) {
    e.preventDefault();
    if (!pro().active) this.checkout();
  }
  features() {
    const keys = ['flarum', 'domain', 'subscribers', 'interval', 'regions', 'history', 'monitors', 'pages', 'branding', 'password', 'realert', 'alert_after', 'alerts', 'security', 'reports', 'evidence'];
    return m("ul", {
      className: "LrPro-features"
    }, keys.map(k => m("li", {
      key: k
    }, m(Icon, {
      name: "fas fa-check"
    }), " ", T('feature.' + k))));
  }

  /** Monthly or yearly, yearly first: it's the better deal. */
  billingChoice(p) {
    const option = (value, label) => m("label", {
      className: "checkbox LrPro-billing"
    }, m("input", {
      type: "radio",
      name: "lrProBilling",
      value: value,
      checked: this.billing === value,
      disabled: this.busy,
      onchange: () => this.billing = value
    }), label);
    return m("div", {
      className: "LrPro-billingChoice"
    }, option('year', T('billing.year', {
      price: p.price,
      saving: p.monthlyPrice * 12 - p.price
    })), option('month', T('billing.month', {
      price: p.monthlyPrice
    })));
  }
  checkout() {
    this.go('checkout', {
      interval: this.billing
    });
  }
  portal() {
    this.go('portal');
  }
  go(which, body) {
    if (body === void 0) {
      body = {};
    }
    this.busy = true;
    this.error = '';
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/lr-billing/pro/${which}`,
      body,
      errorHandler: () => {}
    }).then(res => {
      window.location.href = res.url;
    }).catch(e => {
      this.busy = false;
      this.error = e?.response?.error || extractText(T('failed'));
      m.redraw();
    });
  }

  /** Re-read the forum payload so a membership the webhook just created shows. */
  refresh() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl')
    }).then(payload => {
      app.store.pushPayload(payload);
      m.redraw();
    }).catch(() => {});
  }
}
flarum.reg.add('linkrobins-lr-monitoring', 'components/ProModal', ProModal);